export default new class Search {
    constructor() {
        this.obSearchContainer = $('._search-container');
        this.obSearchInput = this.obSearchContainer.find('._search-input');
        this.obSearchButton = this.obSearchContainer.find('._search-button');
        this.obSearchResultClass = '._search-result-list';
        this.obSearchButtonClear = this.obSearchContainer.find('._search-btn-clear');

        this.handler();
    }

    handler() {
        this.obSearchButton.on('click', (obEvent) => {
            const sSearch = this.obSearchInput.val();
            console.log(obEvent.target);

            oc.request(obEvent.target, 'Search::onSearch', {
                data: {
                    query: sSearch
                },
                update: {
                    'search/result': this.obSearchResultClass
                }
            });
        });
        this.obSearchButtonClear.on('click', (obEvent) => {
            const sSearch = '';
            this.obSearchInput.val('');
            oc.request(obEvent.target, 'Search::onSearch', {
                data: {
                    query: sSearch
                },
                update: {
                    'search/result': this.obSearchResultClass
                }
            });
        });
    }
}();
